// src/components/ServerDatabase/serverDatabaseData.js
// Данные каталога скомпрометированных серверов в точности по эталону ServerDatabase.html

export const DEFAULT_SERVER_DATABASE = [
  {
    id: 'hypixel',
    name: 'Hypixel Network',
    ip: 'mc.hypixel.net',
    port: '25565',
    version: '1.8.9 - 1.21.x',
    versionTag: '1.8',
    core: 'BungeeCord / Paper',
    players: 48290,
    maxPlayers: 100000,
    ping: 24,
    testedHoursAgo: 0.2, // ~12 мин назад
    testedText: '12 минут назад',
    vulnType: 'rcon',
    vulnBadge: 'RCON Доступен',
    vulnDetail: 'Словарь 1M сопоставил RCON порт 25575. Root пароль сохранен в дамп.',
    motdLine1: '<span class="mc-gold mc-bold">Hypixel Network</span>  <span class="mc-gray">[1.8-1.21]</span>  <span class="mc-red mc-bold">SUMMER EVENT</span>',
    motdLine2: '<span class="mc-yellow">•</span> <span class="mc-aqua">SkyBlock 0.20</span> <span class="mc-yellow">•</span> <span class="mc-green">BedWars Tournament</span> <span class="mc-yellow">•</span> <span class="mc-white">play.hypixel.net</span>',
    iconType: 'castle',
    pluginsCount: 42,
    openPorts: ['25565 Game', '25575 RCON (Open)', '8080 WebAPI']
  },
  {
    id: 'funtime',
    name: 'FunTime Anarchy',
    ip: 'play.funtime.su',
    port: '25565',
    version: '1.16.5',
    versionTag: '1.16',
    core: 'Paper 1.16.5',
    players: 7840,
    maxPlayers: 10000,
    ping: 18,
    testedHoursAgo: 0.45, // ~27 мин назад
    testedText: '27 минут назад',
    vulnType: 'rcon',
    vulnBadge: 'RCON Взломан',
    vulnDetail: 'Подобран пароль суперпользователя: fun_adm2024_secure. Доступен шелл.',
    motdLine1: '<span class="mc-light-purple mc-bold">FunTime Anarchy</span> <span class="mc-white">•</span> <span class="mc-yellow">ВАЙП АНАРХИИ СОСТОЯЛСЯ!</span>',
    motdLine2: '<span class="mc-green">Новые сферы и талисманы</span> <span class="mc-gray">|</span> <span class="mc-gold">Подарки /free</span>',
    iconType: 'flame',
    pluginsCount: 56,
    openPorts: ['25565 Game', '25575 RCON (Cracked)', '3306 MySQL']
  },
  {
    id: 'reallyworld',
    name: 'ReallyWorld Grief',
    ip: 'mc.reallyworld.ru',
    port: '25565',
    version: '1.16.5',
    versionTag: '1.16',
    core: 'Velocity / Paper',
    players: 12150,
    maxPlayers: 15000,
    ping: 21,
    testedHoursAgo: 1.1, // 1 ч назад
    testedText: '1 час назад',
    vulnType: 'auth',
    vulnBadge: 'AuthMe Дамп',
    vulnDetail: 'Извлечено 15,200 хэшей аккаунтов игроков и персонала через уязвимость плагина.',
    motdLine1: '<span class="mc-aqua mc-bold">ReallyWorld</span> <span class="mc-gray">»</span> <span class="mc-yellow mc-bold">ЛЕТНИЙ ВАЙП И ОБНОВЛЕНИЕ</span>',
    motdLine2: '<span class="mc-white">Уникальный гриферский сервер</span> <span class="mc-gold">| Скидки до 90%</span>',
    iconType: 'shield',
    pluginsCount: 68,
    openPorts: ['25565 Game', '25577 Proxy', '80 HTTP']
  },
  {
    id: 'holyworld',
    name: 'HolyWorld Anarchy',
    ip: 'mc.holyworld.ru',
    port: '25565',
    version: '1.16.5 - 1.20.4',
    versionTag: '1.20',
    core: 'Purpur / Waterfall',
    players: 4920,
    maxPlayers: 8000,
    ping: 27,
    testedHoursAgo: 2.3, // 2 ч назад
    testedText: '2 часа назад',
    vulnType: 'rcon',
    vulnBadge: 'RCON Доступен',
    vulnDetail: 'Слабый пароль RCON (holy2024!). Команды /op и /stop исполняются без ограничений.',
    motdLine1: '<span class="mc-green mc-bold">HolyWorld</span> <span class="mc-white">•</span> <span class="mc-aqua">Анархия Без Донатных Прав</span>',
    motdLine2: '<span class="mc-yellow">Битвы кланов каждую субботу!</span> <span class="mc-gray">[1.16.5-1.20.4]</span>',
    iconType: 'sword',
    pluginsCount: 47,
    openPorts: ['25565 Game', '25575 RCON (Cracked)']
  },
  {
    id: 'mineblaze',
    name: 'MineBlaze Craft',
    ip: 'play.mineblaze.ru',
    port: '25565',
    version: '1.12.2 - 1.16.5',
    versionTag: '1.12',
    core: 'Spigot 1.12.2',
    players: 2410,
    maxPlayers: 5000,
    ping: 32,
    testedHoursAgo: 3.5, // 3 ч назад
    testedText: '3 часа назад',
    vulnType: 'op',
    vulnBadge: 'OP Bypass',
    vulnDetail: 'Обход проверки разрешений через команду /minecraft:execute и BungeeCord Spoofing.',
    motdLine1: '<span class="mc-red mc-bold">MineBlaze</span> <span class="mc-gray">|</span> <span class="mc-gold">Бесплатный донат новичкам /free</span>',
    motdLine2: '<span class="mc-yellow">Мини-игры, СкайБлок, Выживание с оружием!</span>',
    iconType: 'cube',
    pluginsCount: 38,
    openPorts: ['25565 Game', '3306 MySQL']
  },
  {
    id: 'dexland',
    name: 'DexLand Survival',
    ip: 'play.dexland.net',
    port: '25565',
    version: '1.16.5',
    versionTag: '1.16',
    core: 'Paper 1.16.5',
    players: 1350,
    maxPlayers: 2500,
    ping: 35,
    testedHoursAgo: 5.2, // 5 ч назад
    testedText: '5 часов назад',
    vulnType: 'auth',
    vulnBadge: 'FastLogin Уязвимость',
    vulnDetail: 'Фальсификация UUID лицензии через прокси-заголовки. Вход на аккаунты без пароля.',
    motdLine1: '<span class="mc-aqua mc-bold">DexLand</span> <span class="mc-white">•</span> <span class="mc-green">Ламповое выживание без дюпов</span>',
    motdLine2: '<span class="mc-gold">Квесты, Данжи, Питомцы и Клановые войны</span>',
    iconType: 'globe',
    pluginsCount: 51,
    openPorts: ['25565 Game', '8081 RestAPI']
  },
  {
    id: 'prostocraft',
    name: 'ProstoCraft Network',
    ip: 'play.prostocraft.com',
    port: '25565',
    version: '1.8.8 - 1.20',
    versionTag: '1.8',
    core: 'BungeeCord / Spigot',
    players: 1980,
    maxPlayers: 4000,
    ping: 29,
    testedHoursAgo: 8.0, // 8 ч назад
    testedText: '8 часов назад',
    vulnType: 'rcon',
    vulnBadge: 'RCON Доступен',
    vulnDetail: 'Пароль root консоли rcon: `prosto_admin_pass!`. Доступ ко всем саб-серверам.',
    motdLine1: '<span class="mc-yellow mc-bold">ProstoCraft</span> <span class="mc-gray">«</span> <span class="mc-aqua">SkyWars, BedWars, Murder</span>',
    motdLine2: '<span class="mc-green">Турниры каждую неделю!</span> <span class="mc-white">Онлайн без лагов</span>',
    iconType: 'spark',
    pluginsCount: 63,
    openPorts: ['25565 Game', '25575 RCON (Open)']
  },
  {
    id: 'vimeworld',
    name: 'VimeWorld Legacy Hub',
    ip: 'play.vimeworld.com',
    port: '25565',
    version: '1.8.8',
    versionTag: '1.8',
    core: 'Custom Core / Bungee',
    players: 3450,
    maxPlayers: 7000,
    ping: 22,
    testedHoursAgo: 14.5, // 14 ч назад
    testedText: '14 часов назад',
    vulnType: 'auth',
    vulnBadge: 'Слив Сессий',
    vulnDetail: 'Парсинг токенов авторизации через незашифрованный handshaking шлюз.',
    motdLine1: '<span class="mc-light-purple mc-bold">VimeWorld</span> <span class="mc-white">Custom Client MiniGames</span>',
    motdLine2: '<span class="mc-aqua">ClashPoint, HidenSeek, DeathRun, GunCraft</span>',
    iconType: 'crown',
    pluginsCount: 74,
    openPorts: ['25565 Game', '9000 InternalAPI']
  },
  {
    id: 'aresmine',
    name: 'AresMine ClanWar',
    ip: 'mc.aresmine.ru',
    port: '25565',
    version: '1.16.5',
    versionTag: '1.16',
    core: 'Paper 1.16.5',
    players: 1620,
    maxPlayers: 3000,
    ping: 31,
    testedHoursAgo: 18.0, // 18 ч назад
    testedText: '18 часов назад',
    vulnType: 'op',
    vulnBadge: 'OP Консоль',
    vulnDetail: 'Уязвимость в LuckPerms Web Editor: создание группы с правами * и назначение боту.',
    motdLine1: '<span class="mc-red mc-bold">AresMine</span> <span class="mc-white">•</span> <span class="mc-gold">БИТВА ЗА ТОП КЛАНОВ</span>',
    motdLine2: '<span class="mc-yellow">Награда 50 000 рублей!</span> <span class="mc-green">Присоединяйся сейчас</span>',
    iconType: 'sword',
    pluginsCount: 45,
    openPorts: ['25565 Game', '8080 LuckPerms']
  },
  {
    id: 'mineberry',
    name: 'MineBerry Global',
    ip: 'play.mineberry.net',
    port: '25565',
    version: '1.20.4',
    versionTag: '1.20',
    core: 'Purpur 1.20.4',
    players: 950,
    maxPlayers: 2000,
    ping: 44,
    testedHoursAgo: 21.0, // 21 ч назад
    testedText: '21 час назад',
    vulnType: 'rcon',
    vulnBadge: 'RCON Взломан',
    vulnDetail: 'Открыт порт 25575 со стандартным паролем minecraft. Прямой доступ к операторке.',
    motdLine1: '<span class="mc-green mc-bold">MineBerry</span> <span class="mc-white">|</span> <span class="mc-aqua">Economy SMP [1.20.4]</span>',
    motdLine2: '<span class="mc-gold">Crossplay Java & Bedrock</span> <span class="mc-gray">•</span> <span class="mc-white">Custom Items</span>',
    iconType: 'cube',
    pluginsCount: 39,
    openPorts: ['25565 Game', '25575 RCON (Cracked)', '19132 Bedrock']
  },
  {
    id: 'masedworld',
    name: 'MasedWorld Anarchy',
    ip: 'mc.masedworld.ru',
    port: '25565',
    version: '1.16.5',
    versionTag: '1.16',
    core: 'Paper 1.16.5',
    players: 890,
    maxPlayers: 1500,
    ping: 26,
    testedHoursAgo: 48.0, // 2 дня назад
    testedText: '2 дня назад',
    vulnType: 'auth',
    vulnBadge: 'AuthMe Дамп',
    vulnDetail: 'Слив дампа таблицы authme_users: 8,400 записей, сопоставлено 1,200 паролей.',
    motdLine1: '<span class="mc-gold mc-bold">MasedWorld</span> <span class="mc-gray">»</span> <span class="mc-red">Анархия с крутыми фишками</span>',
    motdLine2: '<span class="mc-yellow">Аукцион, Кастомные чары, Авто-шахта</span>',
    iconType: 'flame',
    pluginsCount: 41,
    openPorts: ['25565 Game', '3306 RemoteDB']
  },
  {
    id: 'simplemc',
    name: 'SimpleMinecraft Ru',
    ip: 'play.simplemc.ru',
    port: '25565',
    version: '1.12.2',
    versionTag: '1.12',
    core: 'Forge 1.12.2 / Sponge',
    players: 540,
    maxPlayers: 1000,
    ping: 38,
    testedHoursAgo: 96.0, // 4 дня назад
    testedText: '4 дня назад',
    vulnType: 'rcon',
    vulnBadge: 'RCON Доступен',
    vulnDetail: 'Слабый пароль консоли RCON: simple2023. Захвачена сессия сервера HiTech.',
    motdLine1: '<span class="mc-aqua mc-bold">SimpleMinecraft</span> <span class="mc-white">•</span> <span class="mc-green">HiTech, Magic, Pixelmon</span>',
    motdLine2: '<span class="mc-gold">Собственный лаунчер</span> <span class="mc-gray">|</span> <span class="mc-white">Стабильная сборка модов</span>',
    iconType: 'shield',
    pluginsCount: 34,
    openPorts: ['25565 Game', '25575 RCON (Open)']
  }
];

// Нормализация серверного DTO в стандартную структуру карточки
export function normalizeServer(server) {
  if (!server) return null;

  // Если сервер уже из DEFAULT_SERVER_DATABASE, возвращаем как есть
  if (server.motdLine1 && server.vulnBadge) {
    return server;
  }

  // Если это DTO из бэкенда (ServerCardDto)
  let rawIp = server.ip || '127.0.0.1';
  let host = rawIp;
  let port = '25565';
  if (rawIp.includes(':')) {
    const parts = rawIp.split(':');
    host = parts[0];
    port = parts[1];
  }

  const id = server.id || host.replace(/[^a-zA-Z0-9]/g, '_');
  const name = server.name || host;
  const version = server.version || '1.16.5';
  const core = server.core || (server.tags && server.tags.length ? server.tags.join(' / ') : 'Paper / Spigot');
  const players = typeof server.players === 'number' ? server.players : (parseInt(server.players, 10) || 0);
  const maxPlayers = server.maxPlayers || Math.max(1000, players * 2);
  const ping = server.ping || 24;
  const testedText = server.lastTested || 'Недавно';

  let vulnType = 'rcon';
  let vulnBadge = 'RCON Доступен';
  let vulnDetail = 'Обнаружен открытый RCON интерфейс. Доступно прямое подключение.';
  if (server.protection === 'vulnerable') {
    vulnType = 'rcon';
    vulnBadge = 'RCON Взломан';
    vulnDetail = 'Критическая уязвимость удаленного выполнения команд. Доступен шелл.';
  } else if (server.protection === 'medium') {
    vulnType = 'auth';
    vulnBadge = 'AuthMe Уязвимость';
    vulnDetail = 'Уязвимость плагина авторизации. Возможен перехват сессий.';
  }

  return {
    id,
    name,
    ip: host,
    port,
    version,
    versionTag: version.split('.')[0] + '.' + (version.split('.')[1] || '0'),
    core,
    players,
    maxPlayers,
    ping,
    testedHoursAgo: 1.0,
    testedText,
    vulnType,
    vulnBadge,
    vulnDetail,
    motdLine1: server.motdLine1 || `<span class="mc-gold mc-bold">${name}</span> <span class="mc-gray">[${version}]</span>`,
    motdLine2: server.motdLine2 || `<span class="mc-green">Сервер проверен сканером StormBlack</span>`,
    iconType: server.iconType || 'castle',
    iconUrl: server.icon || null,
    pluginsCount: server.pluginsCount || 42,
    openPorts: server.openPorts || [`${port} Game`, '25575 RCON']
  };
}
